import React, { useState, useEffect, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { fetchAllProjects } from "../../../store/slices/projectsSlice";
import "react-datepicker/dist/react-datepicker.css";
import { setCurrentPageTitle } from "../../../store/slices/pageSlice";
import MyManagementParent from "./MyManagementParent";
import { setmytrainingOMMyManagement } from "../../../store/slices/OperationSlices/operationStateSlice";
import { IoIosArrowDown } from "react-icons/io";
import { fetchWorkEntriesProjectTracking } from "../../../store/slices/workentriesSlice";
import { useLoggedUser } from "../../../utils/useLoggedUser";
import { fetchEmployees } from "../../../store/slices/employeeAdminSlice";
import { fetchHardwareProjectTracking } from "../../../store/slices/hardwareDescriptionSlice";
import {
  setOngoingHardwareParts,
  setOngoingProjectsRedux,
  setOngoingWorkentries,
} from "../../../store/slices/ProjectOngoing/operationFeatureSlice";
import ManagerAssignment from "../Projectmanager/ProjectRequested/ManagerAssignment";
import { hasViewOrFullAccess } from "../../../utils/featureAccessUtils";

const ProjectManager = () => {
  const dispatch = useDispatch();
  const loggedUser = useLoggedUser();
  const [selectedDash, SetselectedDash] = useState("Management");
  const { projects } = useSelector((state) => state.projects);
  const { projectTrackingWorkEntries } = useSelector(
    (state) => state.workentries
  );
  const { hardwareProjectTracking } = useSelector(
    (state) => state.hardwareDescription
  );
  const { employees } = useSelector((state) => state.employees);

  useEffect(() => {
    dispatch(setCurrentPageTitle(`Operations Managers Dashboard`));
    dispatch(fetchAllProjects());
    dispatch(fetchWorkEntriesProjectTracking());
    dispatch(fetchEmployees());
    dispatch(fetchHardwareProjectTracking());
  }, [dispatch]);

  const popupRef = useRef(null);
  const [showLogout, setshowlogout] = useState(false);
  const [openProbabilityIndex, setOpenProbabilityIndex] = useState(null);
  const [openInputReceived, setOpenInputReceived] = useState(null);
  const [showAlert, setshowAlert] = useState(false);
  const [showManagementDropdown, setShowManagementDropdown] = useState(false);
  const managementDropdownRef = useRef(null);
  const dropdownRefsProbability = useRef([]);
  const [emp, setEmp] = useState("manager");
  const [EmpEmail, setEmpEmail] = useState();
  const [selectedEmp, setSelectedEmp] = useState(null);
  const [selectedEmpOMEmail, setSelectedEmpOMEmail] = useState(null);
  const [ongoingProjectsManager, setOngoingProjectsManager] = useState([]);
  const LoggedUser = localStorage.getItem("email");
  const [ongoingEntries, setongoingEntries] = useState([]);
  const [ongoingHardwareParts, setHardwareParts] = useState([]);
  const [filtereedEmployees, setFiltereedEmployees] = useState([]);
  const [currentEmployee, setCurrentEmployee] = useState(null);
  console.log("selectedEmp selectedEmp", selectedEmp)
  console.log("selectedEmp selectedEmpOMEmail", selectedEmpOMEmail)


  // Only set default selectedEmp on initial load when no selection exists yet
  // Do NOT overwrite when projects refresh - user's selection should persist
  useEffect(() => {
    if (projects.length > 0 && loggedUser && selectedEmp === null) {
      setSelectedEmp(loggedUser);
    }
  }, [projects, loggedUser, selectedEmp]);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        managementDropdownRef.current &&
        !managementDropdownRef.current.contains(event.target) &&
        showManagementDropdown
      ) {
        setShowManagementDropdown(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [showManagementDropdown]); // Add showManagementDropdown as dependency

  const handleManagementClick = () => {
    const wasOnAssignment = selectedDash === "Assignment";

    SetselectedDash("Management");
    dispatch(setmytrainingOMMyManagement(""));

    // If coming from Assignment, always show dropdown
    // If already on Management, toggle dropdown
    if (wasOnAssignment) {
      setShowManagementDropdown(true);
    } else {
      setShowManagementDropdown(!showManagementDropdown);
    }

    if (wasOnAssignment) {
      setSelectedEmp(null);
    }
  };

  // Also update the Assignment button click handler:
  const handleAssignmentClick = () => {
    SetselectedDash("Assignment");
    dispatch(setmytrainingOMMyManagement("Assignment"));
    setShowManagementDropdown(false); // Always close management dropdown
  };

  const handleSelectEmployee = (emp) => {
    console.log("gdgsdg", emp)
    if (emp === "all") {
      setEmp("manager")
      setSelectedEmp(loggedUser);
      setSelectedEmpOMEmail(null);
    } else if (emp === "self") {
      setEmp("self")
      setSelectedEmpOMEmail(loggedUser);
      setSelectedEmp(loggedUser);
    } else {
      setSelectedEmpOMEmail(emp);
      setEmpEmail(emp?.EmpEmail)
      setEmp(emp?.customRoles[0])
      setSelectedEmp(emp);
    }
    setShowManagementDropdown(false);
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        openProbabilityIndex !== null &&
        dropdownRefsProbability.current[openProbabilityIndex] &&
        !dropdownRefsProbability.current[openProbabilityIndex].contains(
          event.target
        )
      ) {
        setOpenProbabilityIndex(null);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [openProbabilityIndex]);

  const dropdownRefOpenInput = useRef([]);
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        openInputReceived !== null &&
        dropdownRefOpenInput.current[openInputReceived] &&
        !dropdownRefOpenInput.current[openInputReceived].contains(event.target)
      ) {
        setOpenInputReceived(null);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [openInputReceived]);

  const handleClickOutside = (event) => {
    if (popupRef.current && !popupRef.current.contains(event.target)) {
      setshowlogout(false);
    }
  };

  useEffect(() => {
    if (showLogout) {
      document.addEventListener("mousedown", handleClickOutside);
    } else {
      document.removeEventListener("mousedown", handleClickOutside);
    }
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, [showLogout]);

  const alertRef = useRef(null);
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (alertRef.current && !alertRef.current.contains(event.target)) {
        setshowAlert(showAlert);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [showAlert]);



  useEffect(() => {
    if (employees.length > 0) {
      if (
        loggedUser?.EmpAuthLevel === "L4" ||
        loggedUser?.customRoles?.includes("project manager")
      ) {
        const operationPerson = employees?.filter(
          (emp) =>
            emp?.EmpAuthLevel === "L4" &&
            emp?.customRoles?.includes("operations")
        );
        const operationWithSameGroup = operationPerson?.filter((emp) =>
          emp.EmpGroups?.some((group) => loggedUser?.EmpGroups?.includes(group))
        );
        const operationWithSameServiceType = operationWithSameGroup.filter(
          (emp) => emp.servicetype === loggedUser?.servicetype
        );
        setFiltereedEmployees(operationWithSameServiceType);
      }
    }
  }, [employees, loggedUser]);

  useEffect(() => {
    const email = localStorage.getItem("email");
    const empData = employees?.find((emp) => emp?.EmpEmail === email) || null;
    setCurrentEmployee(empData);
  }, [employees]);

  const hasNoFeatureConfig =
    !currentEmployee?.featureAccess || currentEmployee.featureAccess.length === 0;
  const canShowManagementTab =
    hasNoFeatureConfig || hasViewOrFullAccess(currentEmployee, "MY MANAGEMENT");
  const canShowAssignmentTab =
    hasNoFeatureConfig ||
    hasViewOrFullAccess(currentEmployee, "MY ASSIGNEMENT") ||
    hasViewOrFullAccess(currentEmployee, "MY ASSIGNMENT");
  const canShowProjectTrackerModule = canShowManagementTab || canShowAssignmentTab;

  useEffect(() => {
    if (!canShowProjectTrackerModule) return;
    if (selectedDash === "Management" && !canShowManagementTab && canShowAssignmentTab) {
      SetselectedDash("Assignment");
    } else if (selectedDash === "Assignment" && !canShowAssignmentTab && canShowManagementTab) {
      SetselectedDash("Management");
    }
  }, [canShowManagementTab, canShowAssignmentTab, canShowProjectTrackerModule, selectedDash]);

  useEffect(() => {
    const filtered = projects.filter(
      (proj) =>
        Array.isArray(proj.Assignedperson) &&
        proj.Assignedperson.some(
          (person) => person.managerstatus === "project ongoing"
        )
    );

    // if (selectedEmpOMEmail) {
    //   const managerProjects = filtered.filter((proj) =>
    //     proj.Assignedperson?.some(
    //       (person) => person.email?.toLowerCase() === selectedEmpOMEmail?.EmpEmail?.toLowerCase()
    //     )
    //   )
    //   setOngoingProjectsManager(managerProjects);
    // } else {
    const managerProjects = filtered.filter((proj) =>
      proj.Assignedperson?.some(
        (person) => person.email?.toLowerCase() === selectedEmp?.EmpEmail?.toLowerCase()
      )
    )
    setOngoingProjectsManager(managerProjects);
    // }


  }, [projects, selectedEmp, LoggedUser, selectedEmpOMEmail]);


  useEffect(() => {
    if (!projectTrackingWorkEntries?.length || !ongoingProjectsManager) {
      setongoingEntries([]);
      return;
    }

    const projectsArray = Array.isArray(ongoingProjectsManager)
      ? ongoingProjectsManager
      : Object.values(ongoingProjectsManager);

    const ongoingProjectIdSet = new Set(
      projectsArray.map((p) => String(p?._id))
    );

    const filtered = projectTrackingWorkEntries.filter((entry) =>
      ongoingProjectIdSet.has(String(entry?.projectid))
    );

    setongoingEntries(filtered);
  }, [projectTrackingWorkEntries, ongoingProjectsManager]);

  useEffect(() => {
    if (
      hardwareProjectTracking?.length > 0 &&
      ongoingProjectsManager?.length > 0
    ) {
      const ongoingProjectIds = ongoingProjectsManager.map(
        (project) => project?._id
      );
      const hardwareParts = hardwareProjectTracking.filter((entry) => {
        const matchesProject = ongoingProjectIds.includes(entry.projectid);
        return matchesProject;
      });
      setHardwareParts(hardwareParts);
    } else {
      setHardwareParts([]);
    }
  }, [ongoingProjectsManager, hardwareProjectTracking]);

  const [filteredOngoingEntries, setFilteredOngoingEntries] = useState([]);
  const [filteredOngoingHardwareParts, setFilteredHardwareParts] = useState([]);
  const [filteredOngoingProjects, setFilteredOngoingProjects] = useState([]);
  
  // Use refs to track previous values and prevent unnecessary Redux updates (prevents flickering)
  const prevFilteredEntriesRef = useRef([]);
  const prevFilteredProjectsRef = useRef([]);
  const prevFilteredHardwareRef = useRef([]);
  
  // console.log("ProjectManager1 filteredOngoingHardwareParts", filteredOngoingHardwareParts)
  console.log("ProjectManager1 filteredOngoingEntries", filteredOngoingEntries);

  // Only reset selectedEmp when switching tabs, not on every loggedUser ref change
  // This prevents overwriting user's employee selection when data refreshes
  useEffect(() => {
    if (selectedDash === "Assignment" && loggedUser) {
      setSelectedEmp(loggedUser);
    } else if (
      selectedDash === "Management" &&
      loggedUser?.EmpAuthLevel === "L4" &&
      loggedUser?.customRoles?.includes("operations")
    ) {
      setSelectedEmp(loggedUser);
    }
  }, [selectedDash, loggedUser]);

  useEffect(() => {
    // My Assignments: show only the logged-in manager's data (no operation personnel)
    if (selectedDash === "Assignment" && loggedUser?._id) {
      setFilteredOngoingEntries(
        ongoingEntries?.filter((e) => e?.taskownerid === loggedUser?._id) ?? []
      );
      setFilteredHardwareParts(
        ongoingHardwareParts?.filter((h) => h?.taskownerid === loggedUser?._id) ?? []
      );
      setFilteredOngoingProjects(ongoingProjectsManager ?? []);
      return;
    }

    if (!selectedEmp) {
      setFilteredOngoingEntries(ongoingEntries);
      setFilteredOngoingProjects(ongoingProjectsManager);
      setFilteredHardwareParts(ongoingHardwareParts ?? []);
    } else {
      if (selectedEmp?._id === loggedUser?._id) {
        setFilteredOngoingEntries(ongoingEntries);
        setFilteredOngoingProjects(ongoingProjectsManager);
        setFilteredHardwareParts(ongoingHardwareParts ?? []);
      } else {
        const filteredEntries = ongoingEntries?.filter(
          (emp) => emp?.taskownerid === selectedEmp?._id
        );
        setFilteredOngoingEntries(filteredEntries);
        const filteredHardwareParts = ongoingHardwareParts?.filter(
          (emp) => emp?.taskownerid === selectedEmp?._id
        );
        setFilteredHardwareParts(filteredHardwareParts);

        const filteredManagers = ongoingProjectsManager?.filter((proj) =>
          proj?.Assignedperson?.some(
            (person) => person?.email === selectedEmp?.EmpEmail
          )
        );
        setFilteredOngoingProjects(filteredManagers);
      }
    }
  }, [
    selectedDash,
    ongoingEntries,
    selectedEmp,
    ongoingProjectsManager,
    ongoingHardwareParts,
    loggedUser,
  ]);

  console.log("ongoingWorkentries1 ongoingEntries", ongoingEntries);

  useEffect(() => {
    // Only update Redux if values have actually changed to prevent flickering
    const entriesChanged = JSON.stringify(prevFilteredEntriesRef.current) !== JSON.stringify(filteredOngoingEntries);
    const projectsChanged = JSON.stringify(prevFilteredProjectsRef.current) !== JSON.stringify(filteredOngoingProjects);
    const hardwareChanged = JSON.stringify(prevFilteredHardwareRef.current) !== JSON.stringify(filteredOngoingHardwareParts);
    
    if (entriesChanged || projectsChanged || hardwareChanged) {
      dispatch(setOngoingWorkentries(filteredOngoingEntries || []));
      dispatch(setOngoingHardwareParts(filteredOngoingHardwareParts || []));
      dispatch(setOngoingProjectsRedux(filteredOngoingProjects || []));
      
      // Update refs
      prevFilteredEntriesRef.current = filteredOngoingEntries || [];
      prevFilteredProjectsRef.current = filteredOngoingProjects || [];
      prevFilteredHardwareRef.current = filteredOngoingHardwareParts || [];
    }
  }, [
    filteredOngoingEntries,
    filteredOngoingHardwareParts,
    filteredOngoingProjects,
    dispatch,
    selectedDash,
  ]);

  return (
    <div className={`bg-[#f3f8f8]  w-full `}>
      <div className=" relative pt-2">
        {canShowProjectTrackerModule && <div className="Selection_Buttons flex gap-2 w-fit">
          {/* <div>
            <button
              onClick={() => {
                SetselectedDash("Management")
                dispatch(setmytrainingOMMyManagement(""))
                setSelectedEmp(null)
              }}
              className={` p-2 flex gap-2 justify-start text-sm align-middle items-center rounded-md 
              ${selectedDash === "Management"
                  ? "bg-yellow-500 text-black font-semibold"
                  : "bg-[#156082] text-white"
                }`}
            >
              My Management
              {selectedDash === "Management" ? (
                <IoIosArrowDown className="font font-semibold" />
              ) : (
                <IoIosArrowDown className="rotate-180 font-semibold" />
              )}
            </button>
          </div> */}

          {canShowManagementTab && <div ref={managementDropdownRef} className="relative">
            <button
              onClick={handleManagementClick}
              className={` p-2 flex gap-2 justify-start text-sm align-middle items-center rounded-md 
              ${selectedDash === "Management"
                  ? "bg-yellow-500 text-black font-semibold"
                  : "bg-[#156082] text-white"
                }`}
            >
              My Management
              {selectedDash === "Management" ? (
                <IoIosArrowDown className="font font-semibold" />
              ) : (
                <IoIosArrowDown className="rotate-180 font-semibold" />
              )}
            </button>

            {/* Dropdown for filtereedEmployees */}
            {showManagementDropdown && selectedDash === "Management" && (
              <div className="absolute text-xs left-0 mt-1 w-40 bg-white border border-gray-300 rounded-md shadow-lg z-10">
                <div className="py-1">
                  {/* All option */}
                  <button
                    onClick={() => handleSelectEmployee("all")}
                    className={`w-full text-left px-3 py-2 hover:bg-gray-100 ${selectedEmp === null ? "bg-blue-50 text-blue-600" : ""
                      }`}
                  >
                    All
                  </button>

                  {/* Self option */}
                  {/* <button
                    onClick={() => handleSelectEmployee("self")}
                    className={`w-full text-left px-3 py-2  hover:bg-gray-100 ${
                      selectedEmp?._id === loggedUser?._id
                        ? "bg-blue-50 text-blue-600"
                        : ""
                    }`}
                  >
                    Self
                  </button> */}

                  {/* Divider */}
                  <div className="border-t border-gray-200 my-1"></div>

                  {/* Employee list */}
                  <div className="max-h-40 overflow-y-auto">
                    {!(
                      loggedUser?.EmpAuthLevel === "L4" &&
                      loggedUser?.customRoles?.includes("operations")
                    ) &&
                      filtereedEmployees.map((emp) => (
                        <button
                          key={emp?._id}
                          onClick={() => handleSelectEmployee(emp)}
                          className={`w-full text-left px-3 py-2 hover:bg-gray-100 ${selectedEmp?._id === emp?._id
                            ? "bg-blue-50 text-blue-600"
                            : ""
                            }`}
                        >
                          {emp.EmpFirstName + " " + emp.EmpLastName}
                        </button>
                      ))}
                  </div>
                </div>
              </div>
            )}
          </div>}

          {canShowAssignmentTab && <button
            onClick={handleAssignmentClick}
            className={` p-2 flex gap-2 justify-start text-sm align-middle items-center rounded-md 
                ${selectedDash === "Assignment"
                ? "bg-yellow-500 text-black font-semibold"
                : "bg-[#156082] text-white"
              }`}
          >
            My Assignments
            {selectedDash === "Assignment" ? (
              <IoIosArrowDown className="font font-semibold" />
            ) : (
              <IoIosArrowDown className="rotate-180 font-semibold" />
            )}
          </button>}
          {/* {selectedDash === "Management" && (
            <button>
              <select
                value={
                  selectedEmp === null
                    ? "all"
                    : selectedEmp?.EmpEmail === loggedUser?.EmpEmail
                      ? "self"
                      : selectedEmp?._id || "all"
                }
                onChange={(e) => {
                  const value = e.target.value;
                  if (value === "all") {
                    setSelectedEmp(null);
                  } else if (value === "self") {
                    setSelectedEmp(loggedUser);
                  } else {
                    const emp = filtereedEmployees.find(emp => emp._id === value);
                    setSelectedEmp(emp);
                  }
                }}
                className={`cursor-pointer bg-white group-hover:bg-gray-100 relative border w-24
               border-gray-400 text-nowrap rounded-md px-2 py-1 text-start overflow-hidden outline-none text-xs font-normal`}
              >
                <option value="all">All</option>
                <option value="self">Self</option>

                {!(loggedUser?.EmpAuthLevel === "L4" && loggedUser?.customRoles?.includes("operations")) && (
                  filtereedEmployees.map(emp => (
                    <option
                      key={emp?._id}
                      value={emp?._id}
                      className="p-0.5 hover:bg-gray-200 cursor-pointer"
                    >
                      {emp.EmpFirstName + " " + emp.EmpLastName}
                    </option>
                  ))
                )}
              </select>
            </button>
          )} */}
        </div>}

        {canShowManagementTab && selectedDash === "Management" && (
          <div className="Manager_Management_Dashboard pt-2">
            <ManagerAssignment
              EmpEmail={EmpEmail}
              emp={emp}
              filteredOngoingEntries={filteredOngoingEntries}
              filteredOngoingProjects={filteredOngoingProjects}
              filteredOngoingHardwareParts={filteredOngoingHardwareParts}
            />
          </div>
        )}

        {canShowAssignmentTab && selectedDash === "Assignment" && (
          <div className="Manager_Assignment_Dashboard pt-2">
            <MyManagementParent
              filteredOngoingEntries={filteredOngoingEntries}
              filteredOngoingProjects={filteredOngoingProjects}
              filteredOngoingHardwareParts={filteredOngoingHardwareParts}
              selectedEmp={selectedEmp}
            />
          </div>
        )}
      </div>
    </div>
  );
};

export default ProjectManager;
